export default {
    namespaced: true,    
    state: {
        obj: {},
        objs: [],
    },
    mutations: {
        setObjs(state, pload) {
            state.objs = pload
        },
        setObj(state, pload) {
            state.obj = pload
        },
    },
    actions: {
        getObj({rootState, commit}, _id){
            return new Promise((resolve, reject) => {            
                let url = rootState.config.apiHost + "holidays/" + _id
                fetch (url, {method: 'get', headers: rootState.apiheaders})
                .then (response => response.json())
                .then (response => {
                    commit('setObj', response)
                    resolve(response)
                }, error => {
                    reject(error)
                })
            })
        },
        postObj({rootState}, pload){
            return new Promise((resolve, reject) => {
                var url = rootState.config.apiHost + 'holidays/'
                fetch(url, {method: 'post', body:JSON.stringify(pload), headers: {'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                .then(response => response.json())
                .then(response => {
                    console.log(response)
                    if (response.result)
                        resolve(response)
                    else
                        reject(response)
                }, error => {
                    reject(error)
                });
            })
        },        
    },
}